import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagMutedRounded = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--muted-rounded', className].filter(Boolean).join(' ')} />
);
